import type { AdminWalletTransaction, CompactUser } from "@shopexperts/legacy-api";
import type { RouteLocationRaw } from "vue-router";

export interface TransactionParty {
  key: string;
  role: string;
  user: CompactUser;
  to?: RouteLocationRaw;
}

export function partyName(user: CompactUser): string {
  return user.name ?? user.email ?? `User #${user.id}`;
}

export function expertProfileRoute(expertId: number): RouteLocationRaw {
  return { name: "admin-expert-detail", params: { expertId: String(expertId) } };
}

export function buildParties(transaction: AdminWalletTransaction): TransactionParty[] {
  const rows: TransactionParty[] = [];
  if (transaction.expert) {
    rows.push({
      key: "expert",
      role: "Expert",
      user: transaction.expert,
      to: expertProfileRoute(transaction.expert.id),
    });
  }
  if (transaction.client) {
    rows.push({ key: "client", role: "Client", user: transaction.client });
  }
  return rows;
}
